module.exports = "../content/893b64ccb17f868c858381956e3c7049.woff2";